<section [formGroup]="employment_info" fxLayout="column" fxLayoutGap="8px">

  <mat-form-field>
    <mat-select placeholder="OFW status" required formControlName="employment_channel">
      <ng-container *ngFor="let status of ofwStatus.list|async">
        <mat-option [value]="status.value">
          {{status.display}}
        </mat-option>
      </ng-container>
    </mat-select>
    <mat-error *ngIf="employment_info.get('employment_channel').hasError('required')">Required.</mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="employment_info.get('employment_channel').value == employment_channel.agency">
    <bb-agency-field formControlName="recruitment_agency"
                     (setAgencyPk)="employment_info.get('agency').setValue($event)"
                     placeholder="Recruitment agency" required></bb-agency-field>
    <mat-error *ngIf="employment_info.get('recruitment_agency').hasError('required')">Required.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput placeholder="Employer" formControlName="employer_name" required>
  </mat-form-field>

</section>
